import { AiOutlineExclamationCircle } from 'react-icons/ai';
import { FiMap, FiList } from 'react-icons/fi';
import { IoMdOptions } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface StyledProps {
  isVisible: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    background: ${({ theme }) => theme.hotelsList.background};
  }

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 966px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
  }
`;

export const FilterTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 16px;
  min-height: 50px;

  @media ${({ theme }) => theme.device.mobile} {
    position: sticky;
    top: 78px;
    background: ${ColorPalette.HEX.Lotion};
    z-index: 2;
    overflow-x: auto;
    flex-wrap: nowrap;
    margin: 0;
    padding-left: 16px;
  }

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 966px;
    margin: 0 auto 8px;
    padding: 0 16px;
  }

  &:empty {
    display: none;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    background: ${ColorPalette.HEX.Lotion};
    height: calc(100vh - 80px);
  }
`;

export const MapButton = styled.div.attrs<any, StyledProps>((): any => ({}))`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px 12px;
  padding-left: 20px;
  pointer-events: ${({ isVisible }) => (isVisible ? 'inherit' : 'none')};
  display: ${({ isVisible }) => (isVisible ? 'inherit' : 'none')};
`;

export const MapLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: ${ColorPalette.HEX.OriolesOrange};
  margin-right: 13px;
  padding-left: 4px;
`;

export const MapIcon = styled(FiMap)`
  font-size: 18px;
  color: ${({ theme }) => theme.hotelsList.icon} !important;
`;

export const ListIcon = styled(FiList)`
  font-size: 18px;
  color: ${({ theme }) => theme.hotelsList.icon} !important;
`;

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 16px 0 0;
    padding-bottom: 110px;
  }
`;

export const FilterIcon = styled(IoMdOptions)`
  font-size: 16px;
  color: ${({ theme }) => theme.flightsList.filter} !important;
`;

export const NotFound: any = styled.h5`
  text-align: center;
  margin: auto 30px;
  padding-bottom: 50px;
  color: ${({ theme }) => theme.flightsList.notFound};
`;

NotFound.Icon = styled(AiOutlineExclamationCircle)`
  margin: 0 auto 15px auto;
  font-size: 25px;
  width: 100%;
`;

export const FloatingFilterContainer = styled.div`
  position: fixed;
  z-index: 4;
  width: fit-content;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 5%;
  left: 50%;
  transform: translate(-50%);
`;

export const Filter: any = styled.span`
  display: flex;
  height: 56px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  align-items: center;
  border-radius: 28px;
  background-color: ${ColorPalette.HEX.White};
  justify-content: space-around;
  box-shadow: 0 2px 16px 0 rgba(${ColorPalette.RGB.Black}, 0.3);

  & > div {
    display: flex;
    width: 50%;
    align-items: center;
    justify-content: center;
  }
`;

Filter.Label = styled.span`
  font-size: 12px;
  margin: 0 4px;
  color: ${ColorPalette.HEX.OriolesOrange};
`;

Filter.Divider = styled.span`
  width: 1px;
  height: 36px;
  background: ${({ theme }) => theme.flightsList.filterDivider};
`;

export const Wrapper = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    width: calc(100% - 270px);
    padding: 0 0 0 16px;
  }
`;

export const LeftContainer = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    width: 270px;
  }
`;
